import React, { useEffect, useState } from 'react';
import {
  View,
  ImageBackground,
  useColorScheme,
  SafeAreaView,
} from 'react-native';
import { Image } from 'react-native';
import { Avatar, Drawer, Button, Divider, Text } from 'react-native-paper';
import { useNavigation, DrawerActions } from '@react-navigation/native';
import { useAppTheme } from '../theme';
import { useAppSelector } from '../redux/hooks';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../Firebase/firebase';
import { Organization } from '../types';
import { getAuth, signOut as firebaseSignOut } from 'firebase/auth';

export function DrawerContent() {
  const theme = useAppTheme();
  const navigation = useNavigation();
  const colorScheme = useColorScheme();
  const auth = getAuth();

  const { user } = useAppSelector((state) => state.user);
  const { organization } = useAppSelector((state) => state.organization);

  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (organization.id !== '') {
      getImageUrl(organization);
    }
  }, [organization]);

  async function getImageUrl(organization: Organization) {
    const orgImageRef = ref(
      storage,
      `organizations/${organization.id}/${organization.imageName}`
    );

    try {
      const url = await getDownloadURL(orgImageRef);
      setImageUrl(url);
    } catch (err) {
      console.log(err);
    }
  }

  function logout() {
    navigation.dispatch(DrawerActions.closeDrawer());
    firebaseSignOut(auth);
  }

  return (
    <ImageBackground
      source={
        colorScheme === 'light'
          ? require('../assets/Drawer-light.png')
          : require('../assets/Drawer-Dark.png')
      }
      resizeMode="cover"
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      <SafeAreaView
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '100%',
          paddingVertical: 20,
        }}
      >
        <View>
          <Drawer.Section
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 20,
              padding: 4,
            }}
          >
            {imageUrl !== '' ? (
              <View
                style={{
                  width: 60,
                  height: 60,
                  backgroundColor: 'black',
                }}
              >
                <Image
                  source={{ uri: imageUrl }}
                  style={{
                    width: '100%',
                    height: '100%',
                    resizeMode: 'cover',
                  }}
                />
              </View>
            ) : (
              <Avatar.Text
                label={organization.name.substring(0, 2).toUpperCase()}
              />
            )}

            <View style={{ marginLeft: 6 }}>
              <Text variant="bodyLarge">{user?.displayName}</Text>
              <Text variant="bodySmall">{user?.email}</Text>
            </View>
          </Drawer.Section>
          <Divider horizontalInset />

          {/* <Drawer.Item
            icon="domain"
            label="User Management"
            // onPress={() => {}}
          /> */}
        </View>

        <Button
          mode="outlined"
          icon="logout"
          onPress={logout}
          textColor={theme.colors.onBackground}
          style={{
            borderColor: theme.colors.onBackground,
            borderRadius: 4,
            margin: 12,
          }}
        >
          Logout
        </Button>
      </SafeAreaView>
    </ImageBackground>
  );
}
